
import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { AccessoryPayloadType, AccessoryType } from "@/common/types/accessory/accessory";

export async function accessoryList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/accessory/list${queryString}`
    );
}

export async function accessoryGet(
    accessory_id: string
) {
    return await clientAxios.get(
        `admin/accessory/${accessory_id}/show`
    );
}

export async function accessoryAdd(
    payload: AccessoryPayloadType
) {
    return await clientAxios.post(
        `admin/accessory/create`,
        payload
    );
}

export async function accessoryCopy(
    accessory_id: string
) {
    return await clientAxios.post(
        `admin/accessory/${accessory_id}/copy`,
        null
    );
}

export async function accessoryPatch(
    accessory_id: string,
    payload: Partial<AccessoryType>
) {
    return await clientAxios.patch(
        `admin/accessory/${accessory_id}/patch`,
        { payload }
    );
}

export async function accessoryDel(
    accessory_id: string,
) {
    return await clientAxios.del(
        `admin/accessory/${accessory_id}/delete`,
    );
}
